<template>
  <div v-if="show" class="modal-backdrop" @mousedown="onBackdropClick">
    <div class="modal" :style="modalstyle">
      <header v-if="showHeader" class="modal-header">
        <slot name="header">&nbsp;</slot>
        <button v-if="closable" type="button" class="close_btn" @click="close">x</button>
      </header>
      <section class="modal-body" :class="{ 'no-padding': noPadding }">
        <slot name="body"> I'm the default body! </slot>
      </section>
      <footer v-if="showFooter" class="modal-footer">
        <slot name="footer">
          I'm the default footer!

          <button type="button" class="btn-green" @click="close">Close me!</button>
        </slot>
      </footer>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue'

const props = defineProps<{
  closable?: boolean
  closeOnOutsideClick?: boolean
  closeOnOutsideHover?: boolean
  showFooter?: boolean
  showHeader?: boolean
  show: boolean
  noPadding?: boolean
  modalstyle?: any
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const close = () => {
  if (props.closable) {
    const wrapper = document.querySelector("#elm") as HTMLElement | null
    if (wrapper) wrapper.style.zIndex = "0"
    emit("close")
  }
}

const onBackdropClick = (event: { target?: HTMLDivElement }) => {
  if (
    event.target?.className === "modal-backdrop" &&
    props.closeOnOutsideClick &&
    props.closable
  ) {
    const wrapper = document.querySelector("#elm") as HTMLElement | null
    if (wrapper) wrapper.style.zIndex = "0"
    emit("close")
  }
}

onMounted(() => {
  const wrapper = document.querySelector("#elm") as HTMLElement | null
  if (wrapper) wrapper.style.zIndex = "2"
})
</script>
<style scoped lang="scss">
.modal-backdrop {
  z-index: 999999;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 !important;
  width: 100vw !important;
  &:before {
    content: "";
    backdrop-filter: blur(5px);
    background-color: rgba(52, 64, 84, 0.7);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
  }
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.2);
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  z-index: 1;
  border-radius: 4px;
}

.modal-header,
.modal-footer {
  padding: 10px 5px 10px 20px;
  display: flex;
  align-items: center;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  justify-content: space-between;
  font-size: 20px;
}

.modal-header span {
  padding: 5px 10px;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px;
  min-width: 400px;

  &.no-padding {
    padding: 0;
  }
}

.close_btn {
  border: none;
  font-size: 20px;
  padding-left: 30px;
  cursor: pointer;
  color: #333;
  background: transparent;
}
</style>
